import React from 'react';
import { Title } from './style';

const TitleComponent = props => {
  const { children, className } = props;
  return (
    <Title
      className={`pl-0 pb-1 ${className !== undefined ? className : ''}`}
    > 
      {children}
    </Title>
  )
};

export default TitleComponent ;